
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import VPNService from './components/VPNService';
import SecurityPrivacy from './components/SecurityPrivacy';
import Support from './components/Support';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navigation from './components/Navigation';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <About />
      <VPNService />
      <SecurityPrivacy />
      <Support />
      <Contact />
      <Footer />
    </div>
  );
}
